import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getArtifactsForDeal = (treeId, dealId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_ARTIFACTS_FOR_DEAL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/discovery-tree/${treeId}/deals/${dealId}`,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_ARTIFACTS_FOR_DEAL_DONE',
              payload: {
                bots: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_ARTIFACTS_FOR_DEAL_FAILED',
              payload: `Failed to get activities for deal`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_ARTIFACTS_FOR_DEAL_FAILED',
            payload: `Failed to get activities for deal`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GETTING_ARTIFACTS_FOR_DEAL_FAILED',
        payload: `Failed to get activities for deal`,
      });
    }
  };
};

export default getArtifactsForDeal;
